import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../lib/data";

const IMAGES = [
  "https://images.unsplash.com/photo-1748525938712-a065b4396ba4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxpbW1lcnNpdmUlMjBsaWdodCUyMGFydCUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3ODM2NTk5NjN8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1506157786151-b8491531f063?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxtdXNpYyUyMGZlc3RpdmFsJTIwY3Jvd2QlMjBsaWdodHN8ZW58MHx8fHwxNzgzNjU5OTYzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1768508948210-a74bb6f9b32d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBldmVudCUyMHN0YWdlJTIwcHJlc2VudGF0aW9ufGVufDB8fHx8MTc4MzY1OTk2M3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1496559249665-c7e2874707ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHx2aWRlb2dyYXBoZXIlMjBmaWxtaW5nJTIwZXZlbnR8ZW58MHx8fHwxNzgzNjU5OTYzfDA&ixlib=rb-4.1.0&q=85",
];

export default function Services() {
  return (
    <section id="services" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-12 gap-8 items-end mb-14 md:mb-20"
        >
          <div className="col-span-12 md:col-span-7">
            <span className="em-tag">01 — Services</span>
            <h2
              className="mt-6 font-display font-extrabold tracking-tighter leading-[0.98]"
              style={{ fontSize: "clamp(2rem, 4.6vw, 4.4rem)" }}
            >
              Four disciplines, one obsession.
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 md:col-start-9 text-white/70 leading-relaxed text-base">
            A single embedded team across strategy, design and live production — from the first idea to the last frame captured on the night.
          </p>
        </motion.div>

        {/* clean uniform 2-col grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
              className="em-card group relative overflow-hidden"
              data-testid={`service-card-${s.id}`}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={IMAGES[i]}
                  alt={s.title}
                  className="w-full h-full object-cover grayscale-[10%] group-hover:grayscale-0 group-hover:scale-[1.04] transition-[transform,filter] duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)]"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/60" />
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="em-tag bg-black/50 backdrop-blur">/ {s.id}</span>
                </div>
              </div>
              <div className="p-6 md:p-8">
                <div className="flex items-start justify-between gap-4">
                  <h3
                    className="font-display font-bold tracking-tight leading-[1.05]"
                    style={{ fontSize: "clamp(1.4rem, 2.2vw, 2rem)" }}
                  >
                    {s.title}
                  </h3>
                  <ArrowUpRight
                    size={18}
                    className="mt-1 shrink-0 opacity-40 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-[transform,opacity] duration-500 text-white"
                  />
                </div>
                <p className="mt-4 text-white/65 text-sm md:text-base leading-relaxed max-w-lg">
                  {s.lead}
                </p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span key={t} className="em-tag">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
